export enum MAP_VIEW_TYPE {
    ol,
    mapbox,
    geoserver,
  }
  
  export enum FEATURE_TYPE {
    controlPoint,
    event
  }